import { io, type Socket } from 'socket.io-client';
import type { CoverageState, DisplaySettings, EventSummary, MessageSocketUpdate, ModerationMessage, PinQueueItem, SalesMentionsPayload, StatsSalesPayload } from '../types';

interface ServerToClientEvents {
  notification: () => void;
  events_update: (events: EventSummary[]) => void;
  new_message: (message: ModerationMessage) => void;
  message_updated: (update: MessageSocketUpdate) => void;
  message_thread: (update: { id: number; who: 'mod' | 'attendee'; name: string | null; text: string }) => void;
  message_deleted: (update: { id: number }) => void;
  messages_reset: (update: { sinceAt: number }) => void;
  pin_update: (queue: PinQueueItem[]) => void;
  room_removed: (update: { event_id?: number | undefined; meeting_id: string }) => void;
  snippets_update: () => void;
  mentions_update: (payload: SalesMentionsPayload) => void;
  coverage_update: (state: CoverageState) => void;
  report_ready: (payload: { eventId: number }) => void;
  stats_dirty: (payload: { eventId?: number }) => void;
  sales_update: (payload: StatsSalesPayload) => void;
  settings_update: (settings: DisplaySettings) => void;
  cutover_read_only: (payload: { error: string }) => void;
}

interface ClientToServerEvents {
  request_coverage: () => void;
  request_settings: () => void;
  av_settings: (settings: DisplaySettings) => void;
}

type ModiqSocket = Socket<ServerToClientEvents, ClientToServerEvents>;

let socket: ModiqSocket | null = null;

const disabledSocket = {
  connected: true,
  on() { return disabledSocket; },
  off() { return disabledSocket; },
  emit() { return disabledSocket; },
  disconnect() { return disabledSocket; },
} as unknown as ModiqSocket;

export function getSocket(): ModiqSocket {
  if (import.meta.env.VITE_DISABLE_SOCKET === 'true') return disabledSocket;
  socket ??= io({ autoConnect: true, transports: ['websocket', 'polling'] });
  return socket;
}

export function closeSocket(): void {
  socket?.disconnect();
  socket = null;
}
